import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { isSysAdmin } from "../loanDetailEditUtil";

import { shouldShowSignor } from "./section-loan-guarantor-docs-row-logic";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Guarantor Docs",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.guarantorDocs"
      }
    ]
  },
  monthlySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Monthly",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.guarantorDocsMonthly"
      }
    ]
  },
  guarantorDocsMonthly: {
    isVisible: data => isSysAdmin(data),
    label: "Guarantor Docs Monthly",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.guarantorDocsMonthly",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsMonthly: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.guarantorDeliveryPeriodMonthly",
        variant: "filled"
      }
    ]
  },
  listOfDocsMonthly: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.guarantorListOfDocsMonthly",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "guarantorDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let guarantorListOfDocsMonthly = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            guarantorListOfDocsMonthly = selectedItems.map(x => ({ id: x, covenantId: covenants.id, configItemId: x, type: "guarantorListOfDocsMonthly" }));
          }
          covenants.guarantorListOfDocsMonthly = guarantorListOfDocsMonthly;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },
  reportingStartDateMonthly: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.guarantorDocsMonthlyReportingStart",
        variant: "filled"
      }
    ]
  },
  quarterlySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Quarterly",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.guarantorDocsQuarterly"
      }
    ]
  },
  guarantorDocsQuarterly: {
    isVisible: data => isSysAdmin(data),
    label: "Guarantor Docs Quarterly",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.guarantorDocsQuarterly",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsQuarterly: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.guarantorDeliveryPeriodQuarterly",
        variant: "filled"
      }
    ]
  },
  listOfDocsQuarterly: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.guarantorListOfDocsQuarterly",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "guarantorDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let guarantorListOfDocsQuarterly = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            guarantorListOfDocsQuarterly = selectedItems.map(x => ({ id: x, covenantId: covenants.id, configItemId: x, type: "guarantorListOfDocsQuarterly" }));
          }
          covenants.guarantorListOfDocsQuarterly = guarantorListOfDocsQuarterly;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },
  reportingStartDateQuarterly: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.guarantorDocsQuarterlyReportingStart",
        variant: "filled"
      }
    ]
  },
  semiAnnuallySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Semi-Annually",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.guarantorDocsSemiAnnually"
      }
    ]
  },
  guarantorDocsSemiAnnually: {
    isVisible: data => isSysAdmin(data),
    label: "Guarantor Docs SemiAnnually",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.guarantorDocsSemiAnnually",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsSemiAnnually: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.guarantorDeliveryPeriodSemiAnnually",
        variant: "filled"
      }
    ]
  },
  listOfDocsSemiAnnually: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.guarantorListOfDocsSemiAnnually",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "guarantorDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let guarantorListOfDocsSemiAnnually = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            guarantorListOfDocsSemiAnnually = selectedItems.map(x => ({
              id: x,
              covenantId: covenants.id,
              configItemId: x,
              type: "guarantorListOfDocsSemiAnnually"
            }));
          }
          covenants.guarantorListOfDocsSemiAnnually = guarantorListOfDocsSemiAnnually;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },
  reportingStartDateAnnuallySemi: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.guarantorDocsSemiAnnuallyReportingStart",
        variant: "filled"
      }
    ]
  },
  annuallySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Annually",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.guarantorDocsAnnually"
      }
    ]
  },
  guarantorDocsAnnually: {
    isVisible: data => isSysAdmin(data),
    label: "guarantor Docs Annually",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.guarantorDocsAnnually",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsAnnually: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.guarantorDeliveryPeriodAnnually",
        variant: "filled"
      }
    ]
  },
  listOfDocsAnnually: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.guarantorListOfDocsAnnually",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "guarantorDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let guarantorListOfDocsAnnually = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            guarantorListOfDocsAnnually = selectedItems.map(x => ({ id: x, covenantId: covenants.id, configItemId: x, type: "guarantorListOfDocsAnnually" }));
          }
          covenants.guarantorListOfDocsAnnually = guarantorListOfDocsAnnually;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },

  reportingStartDateAnnually: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.guarantorDocsAnnuallyReportingStart",
        variant: "filled"
      }
    ]
  },
  generalSubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "General",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      }
    ]
  },
  guarantorOficerCertificate: {
    label: "Officer Certificate",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.guarantorOfficerCertificate",
        variant: "filled",
        hideLabel: true,
        label: "An officer certificate is required."
      }
    ]
  },
  signor: {
    isVisible: data => shouldShowSignor(data),
    label: "Signor",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "covenants.guarantorSignorId",
        variant: "filled",
        parentId: "contacts",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onchange: value => {}
      }
    ]
  }
};
